import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  theme: {
    primary: '#0B109F', //colors.red.darken1, // #E53935
    secondary: '#FF595A', // colors.red.lighten4, // #FFCDD2
    tertiary: '#A7DED5',
    // accent: colors.indigo.base // #3F51B5
  },
  options: {
    customProperties: true
  },
  iconfont: 'md',
})
